import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzNoAnimationModule } from 'ng-zorro-antd/core/no-animation';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';

import { ChipModule } from '@libs/src/chip/chip.module';
import { TextListModule } from '@libs/src/text-list/text-list.module';
import { TtcButtonSharedModule } from '@libs/src/ttc-button-shared/ttc-button-shared.module';
import { TtcMatInputModule } from '@libs/src/ttc-mat-input/ttc-mat-input.module';
import { AccountHubsEditModule } from '@main-client/src/app/account/account-hubs-edit.module';
import { GroupCustomSegmentSelectorModule } from '@main-client/src/app/group-segment-selector/group-custom-segment-selector.module';

import { PrivateSegmentsEditDialogService } from '@main-client/src/app/private-segments-selections/private-segments-edit-dialog/private-segments-edit-dialog.service';

import { PrivateSegmentsEditDialogComponent } from '@main-client/src/app/private-segments-selections/private-segments-edit-dialog/private-segments-edit-dialog.component';
import { PrivateSegmentsSelectionsComponent } from '@main-client/src/app/private-segments-selections/private-segments-selections.component';

import { TranslationLookupListModule } from '../pipes/translation-lookup-list/translation-lookup-list.module';
import { TranslationLookupModule } from '../pipes/translation-lookup/translation-lookup.module';

@NgModule({
  declarations: [
    PrivateSegmentsEditDialogComponent,
    PrivateSegmentsSelectionsComponent,
  ],
  exports: [PrivateSegmentsSelectionsComponent],
  providers: [PrivateSegmentsEditDialogService],
  imports: [
    AccountHubsEditModule,
    ChipModule,
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    GroupCustomSegmentSelectorModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    NzNoAnimationModule,
    NzSelectModule,
    NzTreeSelectModule,
    NzToolTipModule,
    ReactiveFormsModule,
    TextListModule,
    TranslationLookupModule,
    TranslationLookupListModule,
    TtcButtonSharedModule,
    TtcMatInputModule,
  ],
})
export class PrivateSegmentsSelectionsModule {}
